const commonActionTypes = {
  SET_CONTEXT: 'SET_CONTEXT',
  SET_SUB_CONTEXT: 'SET_SUB_CONTEXT',
  SET_TEST_COMMON: 'SET_TEST_COMMON',
};

export default commonActionTypes;
